import { ROUTE_PATH } from "common/constants/sm-constants";
import { MetaModel } from "common/models/utility-models/base-model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";
import { PlacementFilterMetaModel } from "./placement-filter-meta-model";

export class PlacementReportsGridMetaModel extends GridMetaModel<Headers> {
    filterMeta = new PlacementFilterMetaModel().getMetaModel();
    constructor() {
        super(
            'Placement Reports',
            ROUTE_PATH.reports,
            ROUTE_PATH.reports,
            false,
            false,
            8,
            false,
            false,
            ['orgname'],
            false,
            [],
            { isDownloadExcel: true, excelFileName: 'Placement Reports_' + new Date().toLocaleDateString() +'.xlsx', btnLabel: 'Download Placement Report', headers: [{ key: 'StudentName', value: 'orgname' }, { key: 'Branch', value: 'branch_name' }, { key: 'Internship Company Name', value: 'placement_company_name' }, { key: 'Designation', value: 'placement_company_designation' }, { key: 'CTC Offered', value: 'placement_company_package' }, { key: 'Company Location', value: 'placement_company_location' }, { key: 'Status', value: 'statusType' }] },
            false,
            null,
            false,
            false,
            false,
            null,
            { evalKey: 'isDeletable', evalParam: [1], decisiveParam: false },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            false,
            [],
            false,
            { isExtraActions: false, btnLabel: '' },
            {isCheckboxEmit: false, emitKey: '', checkedKey: '', valueKey: ''},
            {
                isDownload: false,
                key: '',
                valueKey: '',
              },
              {
                isTabStatus: false,
                label: '',
                isChecked: false,
              },
              false,
              true,
              {
                isPrimary: true,
                isDanger: false,
              },
              '',
              { value: '', isVisible: false },
              false,
              false
        )
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const studentName = new Headers('Student Name', 'orgname', false, false, 'text');
        const branch = new Headers('Branch', 'branch_name', false, false, 'text');
        const placement_company_name = new Headers('Company Name', 'placement_company_name', false, false, 'text');
        const placement_company_designation = new Headers('Designation', 'placement_company_designation', false, false, 'text');
        const placement_company_package = new Headers('CTC Offered', 'placement_company_package', false, false, 'text');
        const placement_company_location = new Headers('Company Location', 'placement_company_location', false, false, 'text');
        const statusType = new Headers('Status', 'statusType', false, false, 'text');

        headers.push(studentName);
        headers.push(branch);
        headers.push(placement_company_name);
        headers.push(placement_company_designation);
        headers.push(placement_company_package);
        headers.push(placement_company_location);
        headers.push(statusType);

        return headers;
    }

    override getMetaModel(): MetaModel {
        const pageData = new MetaModel();
        pageData.pageTitle = this.pageTitle;
        pageData.properties = this.initProperties();
        pageData.redirectPath = this.redirectPath;
        pageData['filterMeta'] = this.filterMeta;
        return pageData;
      }
}